import firebase from "firebase/app";
import {
    GET_ALL_QUALIFICATIONS,
    GET_ALL_USERS,
    GET_LIST_OF_REQUIRED_QUALIFICATIONS,
    GET_QUALIFICATION_CATEGORIES,
    POST_QUAL_EDIT_INFO,
    SET_ADD_MODAL_INFO,
    SET_QUALIFICATION_TO_DESELECTED,
    SET_QUALIFICATION_TO_SELECTED,
    SET_QUALS_AVAILABLE_SELECTED_CATEGORY,
    SET_QUAL_AVAILABLE_TABLE_PAGE,
    SET_QUAL_AVAILABLE_TABLE_ROW,
    SET_QUAL_EDIT_MODAL_INFO,
    SET_QUAL_SELECTED_TABLE_PAGE,
    SET_QUAL_SELECTED_TABLE_ROW,
    SET_SNACKBAR_STATE,
    POST_REQUIRED_QUALIFICATION,
    POST_UPDATED_USERS,
    SET_DELETE_MODAL_INFO,
    DELETE_QUALIFICATION_FROM_REQUIRED_QUALIFICATIONS,
    DELETE_QUALIFICATION_FROM_USERS,
    SET_QUALS_SELECTED_CATEGORY
} from "./types";
export const getAllQualifications = () => {
    return dispatch => {
        dispatch({ type: GET_ALL_QUALIFICATIONS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/qualifications`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_ALL_QUALIFICATIONS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                } else {
                    dispatch({ type: GET_ALL_QUALIFICATIONS.FAIL });
                }
            });
        } catch (e) {
            dispatch({ type: GET_ALL_QUALIFICATIONS.FAIL });
        }
    };
};
export const setQualificationToSelected = (qualID = false) => {
    return dispatch => {
        dispatch({ type: SET_QUALIFICATION_TO_SELECTED.REQUEST });

        if (qualID) {
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/collections/qualifications/${qualID}`)
                            .update({ qualification_selected: true });
                        dispatch({ type: SET_QUALIFICATION_TO_SELECTED.SUCCESS });
                    } else {
                        dispatch({ type: SET_QUALIFICATION_TO_SELECTED.FAIL });
                    }
                });
            } catch (e) {
                dispatch({ type: SET_QUALIFICATION_TO_SELECTED.FAIL });
            }
        } else {
            dispatch({ type: SET_QUALIFICATION_TO_SELECTED.FAIL });
        }
    };
};

export const setQualificationToDeselected = (qualID = false) => {
    return dispatch => {
        dispatch({ type: SET_QUALIFICATION_TO_DESELECTED.REQUEST });

        if (qualID) {
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/collections/qualifications/${qualID}`)
                            .update({ qualification_selected: false });
                        dispatch({ type: SET_QUALIFICATION_TO_DESELECTED.SUCCESS });
                    } else {
                        dispatch({ type: SET_QUALIFICATION_TO_DESELECTED.FAIL });
                    }
                });
            } catch (e) {
                dispatch({ type: SET_QUALIFICATION_TO_DESELECTED.FAIL });
            }
        } else {
            dispatch({ type: SET_QUALIFICATION_TO_DESELECTED.FAIL });
        }
    };
};
export const setSnackbarState = (state = false) => {
    return dispatch => {
        dispatch({ type: SET_SNACKBAR_STATE, payload: state });
    };
};
export const setQualSelectedTablePage = (page = 0) => {
    return dispatch => {
        dispatch({ type: SET_QUAL_SELECTED_TABLE_PAGE, payload: page });
    };
};
export const setQualAvailableTablePage = (page = 0) => {
    return dispatch => {
        dispatch({ type: SET_QUAL_AVAILABLE_TABLE_PAGE, payload: page });
    };
};
export const setQualAvailableTableRow = (row = 50) => {
    return dispatch => {
        dispatch({ type: SET_QUAL_AVAILABLE_TABLE_ROW, payload: row });
    };
};
export const setQualSelectedTableRow = (row = 50) => {
    return dispatch => {
        dispatch({ type: SET_QUAL_SELECTED_TABLE_ROW, payload: row });
    };
};
export const setQualEditModalInfo = (
    qualInfo = {
        qualID: "",
        qualTitle: false,
        qualExpReq: false,
        qualImgReq: false,
        qualRegReq: false,
        qualVerReq: false
    },
    modalOpen = false
) => {
    return dispatch => {
        dispatch({ type: SET_QUAL_EDIT_MODAL_INFO, payload: { qualInfo, modalOpen } });
    };
};
export const postQualificationUpdateInfo = (
    qualID = null,
    qualExpReq = false,
    qualImgReq = false,
    qualRegReq = false,
    qualVerReq = false
) => {
    return dispatch => {
        if (qualID === null) {
            dispatch({ type: POST_QUAL_EDIT_INFO.FAIL });
        } else {
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/collections/qualifications/${qualID}/`)
                            .update({
                                qualification_expiry_date_required: qualExpReq,
                                qualification_image_required: qualImgReq,
                                qualification_reg_number_required: qualRegReq,
                                qualification_verification_required: qualVerReq
                            });
                        dispatch({ type: POST_QUAL_EDIT_INFO.SUCCESS });
                    } else {
                        dispatch({ type: POST_QUAL_EDIT_INFO.FAIL });
                    }
                });
            } catch {
                dispatch({ type: POST_QUAL_EDIT_INFO.FAIL });
            }
        }
    };
};
export const getQualificationCategories = () => {
    return dispatch => {
        dispatch({ type: GET_QUALIFICATION_CATEGORIES.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/qualification_categories`)
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_QUALIFICATION_CATEGORIES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch {
            dispatch({ type: GET_QUALIFICATION_CATEGORIES.FAIL });
        }
    };
};
export const setQualsAvailableSelectedCategory = (category = "all_categories") => {
    return dispatch => {
        dispatch({ type: SET_QUALS_AVAILABLE_SELECTED_CATEGORY, payload: category });
    };
};
export const setQualsSelectedSelectedCategory = (category = "all_categories") => {
    return dispatch => {
        dispatch({ type: SET_QUALS_SELECTED_CATEGORY, payload: category });
    };
};
export const setAddModalInfo = (
    qualInfo = {
        qualID: "",
        qualTitle: false,
        qualExpReq: false,
        qualImgReq: false,
        qualRegReq: false,
        qualVerReq: false
    },
    modalOpen = false
) => {
    return dispatch => {
        dispatch({ type: SET_ADD_MODAL_INFO, payload: { qualInfo, modalOpen } });
    };
};
export const getAllUsers = () => {
    return dispatch => {
        dispatch({ type: GET_ALL_USERS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/`)
                        .on("value", snapshot => {
                            dispatch({ type: GET_ALL_USERS.SUCCESS, payload: snapshot.val() });
                        });
                } else {
                    dispatch({ type: GET_ALL_USERS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_ALL_USERS.FAIL });
        }
    };
};
export const getRequiredQualifications = () => {
    return dispatch => {
        dispatch({ type: GET_LIST_OF_REQUIRED_QUALIFICATIONS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/required_qualifications/`)
                        .on("value", snapshot => {
                            return {
                                type: GET_LIST_OF_REQUIRED_QUALIFICATIONS,
                                payload: snapshot.val()
                            };
                        });
                } else {
                    dispatch({ type: GET_LIST_OF_REQUIRED_QUALIFICATIONS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_LIST_OF_REQUIRED_QUALIFICATIONS.FAIL });
        }
    };
};
export const postRequiredQualification = (newQualification = false) => {
    return dispatch => {
        if (newQualification) {
            dispatch({ type: POST_REQUIRED_QUALIFICATION.REQUEST });
            let qualID = newQualification.qualification_id;
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/collections/required_qualifications`)
                            .child(`${qualID}`)
                            .update({
                                qualification_category: newQualification.qualification_category,
                                qualification_desc: newQualification.qualification_desc,
                                qualification_expiry_date_required:
                                    newQualification.qualification_expiry_date_required,
                                qualification_id: newQualification.qualification_id,
                                qualification_image_required:
                                    newQualification.qualification_image_required,
                                qualification_invalid_img:
                                    newQualification.qualification_invalid_img,
                                qualification_prefix: newQualification.qualification_prefix,
                                qualification_reg_number_required:
                                    newQualification.qualification_reg_number_required,
                                qualification_selected: newQualification.qualification_selected,
                                qualification_title: newQualification.qualification_title,
                                qualification_valid_img: newQualification.qualification_valid_img,
                                qualification_verification_required:
                                    newQualification.qualification_verification_required
                            })
                            .then(() => {
                                dispatch({ type: POST_REQUIRED_QUALIFICATION.SUCCESS });
                            })
                            .catch(() => {
                                dispatch({ type: POST_REQUIRED_QUALIFICATION.FAIL });
                            });
                    } else {
                        dispatch({ type: POST_REQUIRED_QUALIFICATION.FAIL });
                    }
                });
            } catch {
                dispatch({ type: POST_REQUIRED_QUALIFICATION.FAIL });
            }
        } else {
            dispatch({ type: POST_REQUIRED_QUALIFICATION.FAIL });
        }
    };
};
export const postUpdatedUser = (profile = false, uid = false) => {
    return dispatch => {
        if (uid && profile) {
            dispatch({ type: POST_UPDATED_USERS.REQUEST });
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/users/${uid}`)
                            .update({ profile });
                        dispatch({ type: POST_UPDATED_USERS.SUCCESS });
                    } else {
                        dispatch({ type: POST_UPDATED_USERS.FAIL });
                    }
                });
            } catch {
                dispatch({ type: POST_UPDATED_USERS.FAIL });
            }
        } else {
            dispatch({ type: POST_UPDATED_USERS.FAIL });
        }
    };
};
export const setDeleteModalInfo = (qualID = false, qualTitle = false, modalOpen = false) => {
    return dispatch => {
        dispatch({ type: SET_DELETE_MODAL_INFO, payload: { qualTitle, qualID, modalOpen } });
    };
};
export const deleteQualificationFromRequiredQualifications = (qualID = false) => {
    return dispatch => {
        if (qualID) {
            dispatch({ type: DELETE_QUALIFICATION_FROM_REQUIRED_QUALIFICATIONS.REQUEST });

            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/collections/required_qualifications/`)
                            .child(qualID)
                            .remove()
                            .then(() => {
                                this.getRequiredQualifications();
                                dispatch({
                                    type: DELETE_QUALIFICATION_FROM_REQUIRED_QUALIFICATIONS.SUCCESS
                                });
                            })
                            .catch(() => {
                                dispatch({
                                    type: DELETE_QUALIFICATION_FROM_REQUIRED_QUALIFICATIONS.FAIL
                                });
                            });
                    } else {
                        dispatch({ type: DELETE_QUALIFICATION_FROM_REQUIRED_QUALIFICATIONS.FAIL });
                    }
                });
            } catch {
                dispatch({ type: DELETE_QUALIFICATION_FROM_REQUIRED_QUALIFICATIONS.FAIL });
            }
        } else {
            dispatch({ type: DELETE_QUALIFICATION_FROM_REQUIRED_QUALIFICATIONS.FAIL });
        }
    };
};
export const deleteQualificationFromUsers = (qualID = false, uid = false) => {
    return dispatch => {
        if (qualID && uid) {
            dispatch({ type: DELETE_QUALIFICATION_FROM_USERS.REQUEST });
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/users/${uid}/profile/qualifications_per_user`)
                            .child(qualID)
                            .remove()
                            .then(() => {
                                dispatch({ type: DELETE_QUALIFICATION_FROM_USERS.SUCCESS });
                            })
                            .catch(() => {
                                dispatch({ type: DELETE_QUALIFICATION_FROM_USERS.FAIL });
                            });
                    } else {
                        dispatch({ type: DELETE_QUALIFICATION_FROM_USERS.FAIL });
                    }
                });
            } catch {
                dispatch({ type: DELETE_QUALIFICATION_FROM_USERS.FAIL });
            }
        } else {
            dispatch({ type: DELETE_QUALIFICATION_FROM_USERS.FAIL });
        }
    };
};
